import { render, staticRenderFns } from "./QemuPage.vue?vue&type=template&id=6049d7fa&scoped=true&"
import script from "./QemuPage.vue?vue&type=script&lang=js&"
export * from "./QemuPage.vue?vue&type=script&lang=js&"
import style0 from "./QemuPage.vue?vue&type=style&index=0&id=6049d7fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6049d7fa",
  null
  
)

export default component.exports